import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <div className="relative h-[900px] w-full">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url("/techhero.png")',
        }}
      />
      
      <div className="relative z-10 flex min-h-screen flex-col items-start justify-start px-20 pt-28">
        <h1 className="mb-4 text-3xl font-light text-black md:text-5xl lg:text-8xl">
          Driven by Science.
        </h1>
        
        <p className="text-3xl font-light text-black md:text-5xl lg:text-7xl">
          Designed for the World.
        </p>
      </div>
    </div>
  );
};

export default HeroSection;